import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-16 sm:py-24 bg-teal-50" data-id="element-208">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-210">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8" data-id="element-211">
            RESULTADOS 🧠
          </h2>

          <p className="text-xl text-gray-700 mb-6" data-id="element-212">
            Con el Kit Clínico Cognitivo™ podés:
          </p>

          <ul className="space-y-4" data-id="element-213">
            {['Entrar a cada sesión con el material listo y el objetivo claro', 'Diferenciar el nivel de intervención desde la primera consulta', 'Mostrarle a la familia el progreso con herramientas visuales concretas', 'Cerrar tu día laboral a horario sin llevarte trabajo a casa'].map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-214">
                <Check className="w-6 h-6 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-215" />
                <span className="text-lg text-gray-800" data-id="element-216">{item}</span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}